<template>
  <div class="status-container">
    <el-tabs v-model="status" @tab-click="statusChange">
      <el-tab-pane label="全部商品" name=""></el-tab-pane>
      <el-tab-pane label="出售中" name="5"></el-tab-pane>
      <el-tab-pane label="已下架" name="6"></el-tab-pane>
      <el-tab-pane label="待审核" name="2"></el-tab-pane>
      <el-tab-pane label="驳回" name="3"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: "",
    };
  },
  methods: {
    statusChange(tab) {
      this.$emit("statusChange", tab);
    },
  },
};
</script>

<style lang="scss" scoped>
.status-container {
  margin-top: 20px;
}
</style>
